import { Grid, LinearProgress, Paper, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RedirectKeepUTM } from "../../../shared/components/RedirectKeepUTM";
import { Header } from "../../../shared/components/header";
import { setClose } from "../../../shared/request/actions/requestActions";
import {
  asyncGetFullContentInfo,
  resetEditingAssignedContent,
} from "../../actions/contentActions";
import {
  Article,
  HandleAssignContent,
  MoneyHack,
  Resource,
} from "../../components";
import { useStyles } from "./styles";

export const ViewContentDetail = ({ navigation }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { id: contentId } = useParams();

  const {
    request,
    editingAssignedContent,
    editingContent,
    organizationSettings,
  } = useSelector((state) => ({
    request: state.request.request,
    editingAssignedContent: state.content.editingAssignedContent,
    editingContent: state.content.editingContent,
    organizationSettings: state.auth.login.organization.settings,
  }));

  useEffect(() => {
    dispatch(resetEditingAssignedContent());
    if (contentId) dispatch(asyncGetFullContentInfo(contentId));
  }, [dispatch, contentId]);

  const handleMessageClose = () => {
    dispatch(setClose());
  };

  if (organizationSettings?.isContentFunctionalityEnabled === false) {
    return <RedirectKeepUTM from={`/content/${contentId}`} to="/participant" />;
  }

  return (
    <>
      <Header navigation={navigation}>
        {request.isFetching && (
          <div className={classes.root}>
            <LinearProgress color="secondary" />
          </div>
        )}
        <Grid container justifyContent="flex-end" alignItems="center">
          <HandleAssignContent
            statusId={Number.parseInt(editingAssignedContent.statusId, 10)}
            contentId={Number.parseInt(contentId, 10)}
          />
        </Grid>
        <Grid container component="main">
          <Paper elevation={1} className={classes.container}>
            <Grid
              direction="column"
              justifyContent="space-between"
              alignItems="stretch"
            >
              {editingContent.contentType === "Money Hack" && (
                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                  <MoneyHack
                    data={editingContent}
                    assignedContent={editingAssignedContent}
                  />
                </Grid>
              )}
              {editingContent.contentType === "Article" && (
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                  <Article
                    data={editingContent}
                    assignedContent={editingAssignedContent}
                  />
                </Grid>
              )}
              {editingContent.contentType === "Resource" && (
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                  <Resource
                    data={editingContent}
                    assignedContent={editingAssignedContent}
                  />
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Header>

      <Snackbar
        key="request-message-alert"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={request.isOpen}
        autoHideDuration={6000}
        onClose={handleMessageClose}
      >
        <Alert onClose={handleMessageClose} severity={request.type}>
          {request.message}
        </Alert>
      </Snackbar>
    </>
  );
};

ViewContentDetail.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

ViewContentDetail.defaultProps = {
  navigation: [],
};
